import { observer } from "mobx-react-lite";
import { DisplayItem } from "@menu/core/menu.context";
import { ContextProps } from "@menu/core/types";
import { InboxIcon, SiteLogo, ProfileIcon, SignIn, SignOut, CountryFlagIcon } from "@menu/components/shared";
import SearchIcon from "@menu/components/desktop/search-icon";
import useMenuActions from "@menu/components/use-menu-actions";
import CartIcon from "../shared/cart-icon";
import TopNav from "../desktop/top-nav";
import WishListIcon from "../shared/wishlist-icon";
import AppBanner from "../shared/app-banner";

const MobileTopNav = observer((props: ContextProps) => {
  const { context } = props;

  const { dynamicHeaderSpacing, showAppBanner, useGraphicalMenu } = context.config;

  const { showSearch } = useMenuActions(context);

  if (!context.isMobile) {
    return null;
  }

  const toggleMenu = () => {
    const show = !context.displayMobileNav;
    context.updateDisplayMobileNav(show);

    if (!show) {
      return;
    }

    context.updateDisplayItem(DisplayItem.MainNav);
  }

  const clickFlag = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const newNavState = !context.displayMobileNav;

    context.updateDisplayItem(DisplayItem.MainNav);
    context.updateDisplayMobileNav(newNavState, newNavState);
  }

  const icon = context.displayMobileNav ? "icon-close" : "icon-hamburger-nav";

  const site = context.site;

  const useDynamicSpacing = showAppBanner || !!dynamicHeaderSpacing;

  const dynamicSpacing = useDynamicSpacing ? "dynamic-mobile-menu": "";

  const navCssClass = useGraphicalMenu ? "updated-menu" : "";

  const headerClass = navCssClass + " dynamic";

  //TODO: use context provider rather than using ContextProps
  return (
    <div className={dynamicSpacing}>
      <TopNav context={context} />
      
      <nav id="mobile-header" className={headerClass}>
        <span className="menu-icon">
          <i className={icon} onClick={() => toggleMenu()} />
          <SiteLogo site={site} isMobile={true} spanWrap={false} />
        </span>

        <span className="icons">
          <SearchIcon showSearch={showSearch} />

          <CountryFlagIcon context={context} countryCode={context.countryCode} onClick={clickFlag} />

          <InboxIcon context={context} />

          <CartIcon context={context} />

          <WishListIcon context={context} />

          <ProfileIcon context={context} />

          <SignIn context={context} />

          <SignOut context={context} />
        </span>
      </nav>

      <AppBanner context={context} />
    </div>
  );
});

export default MobileTopNav;